module.exports = __webpack_public_path__ + "img/header-bg.88fe3697.svg";